/* Doku und Begruendung: snippets/tuner-draggable.liquid (rendert 0 Bytes, laedt diese Datei). */
(function () {
  var SEARCH = window.location.search || '';
  if (!/[?&][A-Za-z0-9_-]*tuner=1(?:&|$)/.test(SEARCH)) return;

  var PREFIX = 'vivTunerPos:';
  var MARGIN = 4;           // Mindestabstand zum Fensterrand
  var HANDLE_RESERVE = 120; // so viel Panel muss unten sichtbar bleiben
  var DEFAULT_TOP = 80;     // Standard: mittig, etwas unterhalb der Oberkante

  var css = document.createElement('style');
  css.textContent =
    '[id$="-tuner"] .kt-title{cursor:move;user-select:none;-webkit-user-select:none}' +
    '[id$="-tuner"] .kt-drag-hint{font-weight:400;font-size:10px;opacity:.7;' +
      'margin-left:8px;white-space:nowrap}' +
    '[id$="-tuner"].viv-tuner-dragging{opacity:.92;box-shadow:0 8px 32px rgba(0,0,0,.35)}';
  (document.head || document.documentElement).appendChild(css);

  var panels = [];   // alle bereits angehaengten Panels (fuer resize)
  var active = null; // laufender Zieh-Vorgang

  function makePanel(el) {
    var key = PREFIX + (el.id || 'tuner');

    function defaultPos() {
      var w = el.offsetWidth || 300;
      return { left: Math.max(MARGIN, Math.round((window.innerWidth - w) / 2)), top: DEFAULT_TOP };
    }
    function clamp(p) {
      var w = el.offsetWidth || 300, h = el.offsetHeight || 200;
      return {
        left: Math.min(Math.max(MARGIN, p.left), Math.max(MARGIN, window.innerWidth - w - MARGIN)),
        top: Math.min(Math.max(MARGIN, p.top),
                      Math.max(MARGIN, window.innerHeight - Math.min(h, HANDLE_RESERVE) - MARGIN))
      };
    }
    function apply(p, save) {
      var c = clamp(p);
      // inline schlaegt die #id-Regel im SKU-Snippet (left:10px;bottom:10px)
      el.style.left = c.left + 'px';
      el.style.top = c.top + 'px';
      el.style.right = 'auto';
      el.style.bottom = 'auto';
      if (save) { try { window.localStorage.setItem(key, JSON.stringify(c)); } catch (e) {} }
    }
    function current() {
      return { left: parseFloat(el.style.left) || 0, top: parseFloat(el.style.top) || 0 };
    }
    return { el: el, apply: apply, current: current, defaultPos: defaultPos };
  }

  function attach(el) {
    if (el.__vivTunerDrag) return;
    var handle = el.querySelector('.kt-title');
    if (!handle) return;              // kein Griff -> spaeterer Scan versucht es erneut
    el.__vivTunerDrag = true;

    var p = makePanel(el);
    panels.push(p);

    var saved = null;
    try { saved = JSON.parse(window.localStorage.getItem(PREFIX + (el.id || 'tuner')) || 'null'); }
    catch (e) {}
    var ok = saved && typeof saved.left === 'number' && typeof saved.top === 'number';
    p.apply(ok ? saved : p.defaultPos(), false);

    if (!handle.querySelector('.kt-drag-hint')) {
      var hint = document.createElement('span');
      hint.className = 'kt-drag-hint';
      hint.textContent = 'ziehen · 2× Klick = zurück';
      handle.appendChild(hint);
    }

    handle.addEventListener('mousedown', function (ev) {
      if (ev.button !== 0) return;
      var r = el.getBoundingClientRect();
      active = { p: p, dx: ev.clientX - r.left, dy: ev.clientY - r.top };
      el.classList.add('viv-tuner-dragging');
      ev.preventDefault();            // sonst startet der Browser eine Textauswahl
    });
    handle.addEventListener('dblclick', function () { p.apply(p.defaultPos(), true); });
  }

  document.addEventListener('mousemove', function (ev) {
    if (!active) return;
    active.p.apply({ left: ev.clientX - active.dx, top: ev.clientY - active.dy }, false);
  });
  document.addEventListener('mouseup', function () {
    if (!active) return;
    active.p.el.classList.remove('viv-tuner-dragging');
    active.p.apply(active.p.current(), true);
    active = null;
  });
  window.addEventListener('resize', function () {
    for (var i = 0; i < panels.length; i++) panels[i].apply(panels[i].current(), false);
  });

  function scan() {
    var list = document.querySelectorAll('[id$="-tuner"]');
    for (var i = 0; i < list.length; i++) attach(list[i]);
  }

  function boot() {
    scan();
    // Panels werden erst beim Oeffnen gebaut, manche fuellen ihren Inhalt
    // nachtraeglich — deshalb bei jeder DOM-Aenderung erneut scannen. Das laeuft
    // ausschliesslich in einer Tuner-Sitzung, nie im Kundenbetrieb.
    if (window.MutationObserver) {
      new window.MutationObserver(scan).observe(document.body, { childList: true, subtree: true });
    }
  }

  if (document.body) boot();
  else document.addEventListener('DOMContentLoaded', boot);
})();
